import { render, staticRenderFns } from "./CheckRepeal.vue?vue&type=template&id=67fd2aba&scoped=true&"
import script from "./CheckRepeal.vue?vue&type=script&lang=js&"
export * from "./CheckRepeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd2aba",
  null
  
)

export default component.exports